import { useCallback, useEffect } from "react";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { getEQM1011_R01List, getEQM1011_R01TagList } from "./Api_EQM1011_R01";
import { useEQM1011_R01Store } from "./Store_EQM1011_R01";

interface EQM1011_R01ContentProps {
    setMessage: (message: string) => void;
}

export const Content_EQM1011_R01 = ({ setMessage }: EQM1011_R01ContentProps) => {
    const {
        EQM1011_R01Filter,
        setEQM1011_R01List,
        setEQM1011_R01TagList,
        setScrollTop,
        initData,
    } = useEQM1011_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();

    useFetchActionbarAuth("EQM1011_R01");

    // 화면 진입 시 "데이터종류" 선택 목록(plc_tag)을 1회 조회한다. 수집 이력 목록은 자동 조회하지 않는다(조회 버튼으로만 조회)
    useEffect(() => {
        /** 태그 목록을 Store에 저장한다. 실패하면 빈 목록을 유지하고 경고만 표시한다. */
        const fetchTagList = async () => {
            try {
                const response = await getEQM1011_R01TagList();
                // 응답 data가 없으면 빈 배열로 둔다
                setEQM1011_R01TagList(response.data.data ?? []);
            } catch (error) {
                console.error('EQM1011_R01 데이터종류 목록 조회 실패:', error);
                showWarning('데이터종류 목록을 불러오지 못했습니다.');
            }
        };
        fetchTagList();
    }, [setEQM1011_R01TagList]);

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);

        try {
            setScrollTop(null);
            const listResponse = await getEQM1011_R01List(EQM1011_R01Filter);
            const fetchedList = listResponse.data.data;
            setEQM1011_R01List(fetchedList);

            if (fetchedList.length === 0) {
                showWarning('조회된 데이터가 없습니다.');
                return;
            }

            ShowSuccessFetch(
                setMessage,
                `조회가 완료되었습니다. (총 ${fetchedList.length}건)`,
            );
        } catch (error) {
            console.error('EQM1011_R01 데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
        } finally {
            setLoadingSpinner(false);
        }
    }, [
        EQM1011_R01Filter,
        setEQM1011_R01List,
        setLoadingSpinner,
        setMessage,
        setScrollTop,
    ]);

    const handleInitClick = useCallback(() => {
        initData();
        setMessage('데이터가 초기화되었습니다.');
    }, [initData, setMessage]);

    return { fetchData, handleInitClick };
};
